import { Injectable } from '@angular/core';
import { BaseApiService, PagedResult, IPagedRequest } from '@onrsr/ui/core';
import { Occurrence } from '../models/occurrence';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class OccurrenceService extends BaseApiService<Occurrence> {
  constructor() {
    super('occurrences');
  }

  public getOccurrences(pagedRequest?: IPagedRequest): Observable<PagedResult<Occurrence>> {
    return this.getPagedResult(pagedRequest);
  }

  public getOccurrence(id: number): Observable<Occurrence> {
    return this.get(id.toString());
  }

  public updateOccurrence(id: number, occurrence: Occurrence): Observable<Occurrence> {
    return this.update(id.toString(), occurrence);
  }
}
